import { render, staticRenderFns } from "./unauthorized.vue?vue&type=template&id=e33a52a4&scoped=true&"
import script from "./unauthorized.vue?vue&type=script&lang=js&"
export * from "./unauthorized.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./unauthorized.vue?vue&type=style&index=0&id=e33a52a4&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "e33a52a4",
  "57bc8330"
  
)

export default component.exports